import { render, staticRenderFns } from "./rptcustomerorder.vue?vue&type=template&id=50e36e29"
import script from "./rptcustomerorder.vue?vue&type=script&lang=js"
export * from "./rptcustomerorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports